import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const ActivitiesIncentives = lazy(() =>
  import(/* webpackChunkName: "ActivitiesIncentives" */ '../../components/rewards/ActivitiesIncentives')
);

export default function AsyncActivitiesIncentives({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <ActivitiesIncentives {...props} />
    </Suspense>
  );
}
